import { render, staticRenderFns } from "./FileServeUpload.vue?vue&type=template&id=1506e852&"
import script from "./FileServeUpload.vue?vue&type=script&lang=js&"
export * from "./FileServeUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports